import { IPiNxtAPIResponse, IPiNxtTokenAPIResponse } from 'types/pinxt';
import { genJwtToken } from './pinxt.utils';

/**
 * Mock PiNXt Auth Step 2 of 2: Requesting auth tokens (authToken, IdToken, etc.)
 */
export const getTokens = (): IPiNxtTokenAPIResponse => {
  const mockToken = genJwtToken();
  return {
    resultCode: '200',
    resultCodeName: 'PROCESSED',
    resultMessage: 'PROCESSED',
    token_type: 'bearer',
    access_token: mockToken,
    expires_in: '3600', // 60 mins
    id_token: mockToken,
    refresh_token: mockToken,
  };
};

/**
 * Mock Logs out of current session
 */
export const logout = (): IPiNxtAPIResponse => {
  return {
    resultCode: '200',
    resultCodeName: 'PROCESSED',
    resultMessage: 'PROCESSED',
  };
};
